var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-list-group-item',[_c('b-row',[_c('b-col',{staticClass:"text-pod",attrs:{"cols":_vm.cols || 6}},[_vm._v(_vm._s(_vm.metric)+":")]),_c('b-col',[_vm._t("default",[_vm._v(_vm._s(_vm.value))])],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }